import { gql } from "@apollo/client";

export const QUICK_CHECK_VALIDATION = gql`
    query quickCheckValidation($partnerId:String!){
        quickCheckValidation(partnerId:$partnerId){
            ok
        }
    }
`;